
import Maximize21 from "../../../assets/duotone/Maximize21.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Maximize21Icon({ className, dataTestid = "Maximize21Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Maximize21 data-testid={dataTestid} className={classes} {...rest} />
  );
}
